// TODO: Fix ESLint complexity issue
import { CButton, CButtonGroup, CInput, CSelect } from "@coreui/react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useEffect, useState } from "react";

import PropTypes from "prop-types";

const defaultFilterOnFieldName = null;
const defaultComparisonOperator = "eq";
const defaultValueDatatype = "string";
const defaultValue = "";

export const initialWhereFilterValue = {
  filter_on: { group: "dataset", name: "" },
  comparison_operator: "eq",
  value_datatype: "string",
  filter_value: "",
};

export const AddWhereFilterButton = ({ onAddFilter, disabled }) => {
  return (
    <CButton
      color="primary"
      size="sm"
      onClick={onAddFilter}
      disabled={disabled}
    >
      <FaPlus />
    </CButton>
  );
};

AddWhereFilterButton.propTypes = {
  onAddFilter: PropTypes.func,
  disabled: PropTypes.bool,
};

AddWhereFilterButton.defaultProps = {
  onAddFilter: () => {},
  disabled: false,
};

export const RemoveWhereFilterButton = ({ onRemoveFilter, disabled }) => {
  return (
    <CButton
      color="danger"
      size="sm"
      onClick={onRemoveFilter}
      disabled={disabled}
      style={{ marginBottom: "5px" }}
    >
      <FaMinus />
    </CButton>
  );
};

RemoveWhereFilterButton.propTypes = {
  onRemoveFilter: PropTypes.func,
  disabled: PropTypes.bool,
};

RemoveWhereFilterButton.defaultProps = {
  onRemoveFilter: () => {},
  disabled: false,
};

const WhereFilter = (props) => {
  const [filter_on, setFilterOn] = useState(
    props.value.filter_on || defaultFilterOnFieldName,
  );
  const [comparison_operator, setComparisonOperator] = useState(
    props.value.comparison_operator || defaultComparisonOperator,
  );
  const [value_datatype, setValueDatatype] = useState(
    props.value.value_datatype || defaultValueDatatype,
  );
  const [filter_value, setFilterValue] = useState(
    props.value.filter_value || defaultValue,
  );

  useEffect(() => {
    if (props.value.filter_on !== filter_on) {
      setFilterOn(props.value.filter_on || defaultFilterOnFieldName);
    }
    if (props.value.comparison_operator !== comparison_operator) {
      setComparisonOperator(
        props.value.comparison_operator || defaultComparisonOperator,
      );
    }
    if (props.value.value_datatype !== value_datatype) {
      setValueDatatype(props.value.value_datatype || defaultValueDatatype);
    }
    if (props.value.filter_value !== filter_value) {
      setFilterValue(props.value.filter_value || defaultValue);
    }
  }, [props.value]);

  const [filterIsReady, setFilterIsReady] = useState(false);

  const cellStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
  };

  const filterStarted = filter_on?.name !== "" || filter_value !== "";
  const filterOnInvalid = filterStarted && filter_on?.name === "";
  const filterValueInvalid =
    (filterStarted && filter_value === "") ||
    (value_datatype === "boolean" && filter_value === "");

  useEffect(() => {
    // Checks if filter is ready to be pushed back to parent component
    let filterHasValue = filter_value !== "";

    if (
      !filterValueInvalid &&
      filterHasValue &&
      filter_on &&
      comparison_operator &&
      value_datatype
    ) {
      setFilterIsReady(true);
    } else {
      setFilterIsReady(false);
    }
  }, [
    filter_on,
    comparison_operator,
    filter_value,
    value_datatype,
    filterValueInvalid,
  ]);

  useEffect(() => {
    // Pushes the filter back to the parent component when ready
    if (filterIsReady) {
      props.setFilterReady(true);
      props.onValidFilter({
        filter_on,
        comparison_operator,
        filter_value,
        value_datatype,
      });
    } else {
      props.setFilterReady(false);
    }
  }, [
    filterIsReady,
    filter_on,
    comparison_operator,
    filter_value,
    value_datatype,
  ]);

  return (
    <div style={{ display: "flex", flexDirection: "row", maxWidth: "100%" }}>
      <div style={cellStyle}>
        {props.includeHeader && "Column"}
        <CSelect
          id="filter-on-select"
          name="filterOn"
          value={props.fields?.findIndex(
            (field) =>
              field.id === filter_on?.id &&
              field.field_name === filter_on?.name,
          )}
          onChange={(e) => {
            const selectedFilter = props.fields[e.target.value];
            if (!selectedFilter) {
              return;
            }
            const newFilterOn = {
              group: props.group,
              name: selectedFilter.field_name,
              column: selectedFilter.column,
              modelOutputName: selectedFilter.modelOutputName,
              id: selectedFilter.id,
            };
            setFilterOn(newFilterOn);
          }}
          style={{
            maxWidth: "175px",
            outline: filterOnInvalid && "1px solid red",
            flexShrink: 3,
          }}
          disabled={props.disabled}
        >
          <option value="">Choose a column</option>
          {props.fields?.map((df, index) => {
            return (
              <option key={df.id} value={index}>
                {df.display_name ? df.display_name : df.field_name}
              </option>
            );
          })}
        </CSelect>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minWidth: "13%",
          alignItems: "center",
        }}
      >
        {props.includeHeader && <>&nbsp;</>}
        <CSelect
          id="comparison-operator-select"
          name="comparisonOperator"
          value={comparison_operator}
          style={{ textAlign: "center" }}
          onChange={(e) => {
            setComparisonOperator(e.target.value);
          }}
          disabled={props.disabled}
        >
          <option value="eq">=</option>
          <option value="ne">&ne;</option>
          <option value="lt">&lt;</option>
          <option value="gt">&gt;</option>
          <option value="le">&le;</option>
          <option value="ge">&ge;</option>
          <option value="like">like</option>
        </CSelect>
      </div>
      <div
        style={{
          minWidth: "21%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {props.includeHeader && "Type"}
        <CSelect
          id="value-datatype-select"
          name="valueDatatype"
          value={value_datatype}
          onChange={(e) => {
            setValueDatatype(e.target.value);
          }}
          disabled={props.disabled}
        >
          <option value="string">Text</option>
          <option value="float" disabled={comparison_operator === "like"}>
            Number
          </option>
          <option value="date" disabled={comparison_operator === "like"}>
            Date
          </option>
          <option value="boolean" disabled={comparison_operator === "like"}>
            Boolean
          </option>
        </CSelect>
      </div>

      <div style={cellStyle}>
        {props.includeHeader && "Value"}
        {value_datatype !== "boolean" ? (
          <CInput
            id="filter-value-input"
            name="filterValue"
            minLength={2}
            debounceTimeout={300}
            style={{
              maxWidth: "100%",
              outline: filterValueInvalid && "1px solid red",
            }}
            type={
              value_datatype === "string"
                ? "text"
                : value_datatype === "float"
                  ? "number"
                  : value_datatype === "date"
                    ? "date"
                    : ""
            }
            onChange={(e) => {
              setFilterValue(e.target.value);
            }}
            autoComplete={"off"}
            disabled={props.disabled}
            value={filter_value}
          />
        ) : (
          <CSelect
            name="booleanSelect"
            value={filter_value}
            style={{
              maxWidth: "100%",
              outline: filterValueInvalid && "1px solid red",
            }}
            onChange={(e) => {
              setFilterValue(e.target.value);
            }}
            disabled={props.disabled}
          >
            <option value="">Select</option>
            <option value="true">true</option>
            <option value="false">false</option>
          </CSelect>
        )}
      </div>
      <CButtonGroup
        style={{
          display: "flex",
          flexDirection: "column",
          float: "left",
          marginLeft: 5,
          marginTop: props.includeHeader ? "23px" : "2px",
        }}
      >
        {props.removeFilterEnabled && !props.disabled && (
          <RemoveWhereFilterButton onRemoveFilter={props.onRemoveFilter} />
        )}
        {props.addFilterEnabled && !props.disabled && (
          <AddWhereFilterButton
            onAddFilter={props.onAddFilter}
            disabled={!filterIsReady}
          />
        )}
      </CButtonGroup>
    </div>
  );
};

WhereFilter.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  group: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  value: PropTypes.object,
  includeHeader: PropTypes.bool,
  onValidFilter: PropTypes.func,
  onAddFilter: PropTypes.func,
  onRemoveFilter: PropTypes.func,
  addFilterEnabled: PropTypes.bool,
  removeFilterEnabled: PropTypes.bool,
  disabled: PropTypes.bool,
  setFilterReady: PropTypes.func,
};

WhereFilter.defaultProps = {
  value: initialWhereFilterValue,
  fields: [],
  includeHeader: true,
  addFilterEnabled: true,
  removeFilterEnabled: true,
  onValidFilter: () => {},
  onAddFilter: () => {},
  onRemoveFilter: () => {},
  disabled: false,
};

export default WhereFilter;
